import axios from 'axios';
import { API_BASE_URL } from '../config';

// 登录函数
export const login = async (username, password) => {
  try {
    console.log(`尝试登录: ${username}`);
    console.log(`API_BASE_URL: ${API_BASE_URL}`);
    const response = await axios.post(`${API_BASE_URL}/auth/login`, { username, password });
    console.log('登录响应:', response.data);
    return response.data;
  } catch (error) {
    console.error('登录错误:', error);
    if (error.response) {
      console.error('错误状态码:', error.response.status);
      console.error('错误数据:', error.response.data);
    }
    throw new Error(error.response?.data?.error || '登录失败');
  }
};

// 注册函数
export const register = async (userData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/register`, userData);
    return response.data;
  } catch (error) {
    console.error('注册错误:', error);
    throw new Error(error.response?.data?.message || '注册失败');
  }
};

// 获取当前用户信息
export const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('无token，不获取用户信息');
      return null;
    }
    
    console.log('获取当前用户信息, token:', token.substring(0, 10) + '...');
    console.log('请求URL:', `${API_BASE_URL}/auth/me`);

    try {
      const response = await axios.get(`${API_BASE_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log('获取用户信息成功:', response.data);
      
      // 处理API返回的包装格式：{ data: { 用户信息 } }
      if (response.data && response.data.data) {
        return response.data.data; // 返回包装在data字段中的用户数据
      } else {
        return response.data; // 兼容旧格式，直接返回响应数据
      }
    } catch (error) {
      console.error('获取用户信息失败', error);
      console.error('错误类型:', error.name);
      console.error('错误信息:', error.message);
      if (error.response) {
        console.error('错误状态码:', error.response.status);
        console.error('错误数据:', error.response.data);
        console.error('错误头信息:', error.response.headers);
      } else if (error.request) {
        console.error('请求已发送但未收到响应:', error.request);
      }
      return null;
    }
  } catch (error) {
    console.error('获取用户信息总体失败', error);
    return null;
  }
};

// 登出函数
export const logout = async () => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      // 调用后端登出接口
      await axios.post(`${API_BASE_URL}/auth/logout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    }
  } catch (error) {
    console.error('登出错误:', error);
  } finally {
    // 无论是否调用成功，都清除本地存储
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return true;
  }
};  
